import _ from 'lodash';
import filesize from 'filesize';
import helpers from './helpers';

const s3 = {
  /**
   * @param {string} mime - Mime type
   */
  getS3Request(mime) {
    return helpers.request(`s3-request?fileType=${mime}`, helpers.requestOptions('GET'));
  },
  /**
   * @param {string} mime - Mime type
   * @param {object} data - Data to upload to S3
   */
  putS3(mime, data) {
    return s3.getS3Request(mime)
      .then(res => fetch(res, {
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': mime,
        },
      }))
      .then((res) => {
        const payload = {
          uri: _.first(_.split(res.url, '?')),
          size: filesize(data.size).toLowerCase(),
        };
        return payload;
      });
  },
};

export default s3;
